module.exports = __webpack_public_path__ + "0238fa72fdd9b0d3b581c9c0a82bbfe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room6/audio1/06_a-la-belle-etoile_room.jpg
// module id = 230
// module chunks = 0